module.exports = __webpack_public_path__ + "img/bg4.b8558476.jpg";